import { mapboxClient, addressSearchClient } from "../lib/clients";

const MapboxAPI = {
  async suggestCities(query, accessToken, sessionToken) {
    return mapboxClient.get(
      `/search/searchbox/v1/suggest?q=${query}&language=pt&country=br&types=city&access_token=${accessToken}&session_token=${sessionToken}`
    );
  },

  async getCityDetails(cityName) {
    return addressSearchClient.get(
      `/api/?q=${encodeURIComponent(cityName)}&lang=en&limit=1`
    );
  },
};

export default MapboxAPI;
